import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=c2ceae1e&scoped=true&"
import script from "./reset-password.vue?vue&type=script&lang=js&"
export * from "./reset-password.vue?vue&type=script&lang=js&"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=c2ceae1e&prod&lang=css&"
import style1 from "./reset-password.vue?vue&type=style&index=1&id=c2ceae1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ceae1e",
  null
  
)

export default component.exports